import React from 'react';

type SplitDirection = 'horizontal' | 'vertical';

// хук: < 960 => vertical, иначе horizontal
export const useResponsiveSplitDirection = (breakpoint = 960): SplitDirection => {
  const get = () => (window.matchMedia(`(max-width: ${breakpoint - 1}px)`).matches ? 'vertical' : 'horizontal');

  const [dir, setDir] = React.useState<SplitDirection>(() => {
    if (typeof window === 'undefined') return 'horizontal';
    return get();
  });

  React.useEffect(() => {
    const mq: any = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = () => setDir(mq.matches ? 'vertical' : 'horizontal');

    if ('addEventListener' in mq) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);

    onChange();

    return () => {
      if ('removeEventListener' in mq) mq.removeEventListener('change', onChange);
      else mq.removeListener(onChange);
    };
  }, [breakpoint]);

  return dir;
};
